var _circle, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountOrderRefundPopupNoTestsForRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 118,
    r: 118,
    fill: "#F3F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.031 202.844C216.256 202.844 218.041 201.047 218.041 198.824V89.7805H219.19V198.824C219.19 201.688 216.892 204 214.031 204H21.1617C18.325 204 16.0022 201.688 16.0022 198.824V191.228H17.1509V198.824C17.1509 201.047 18.9363 202.844 21.1617 202.844H214.031ZM219.19 89.7805H218.041V38.1585C218.041 35.9349 216.256 34.1383 214.031 34.1383H21.1617C18.9363 34.1383 17.1509 35.9349 17.1509 38.1585V64.8233H16.0022V38.1585C16.0022 35.3123 18.325 33 21.1617 33H214.031C216.892 33 219.19 35.3123 219.19 38.1585V89.7805Z",
    fill: "#151515"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.0022,
    y: 34,
    width: 201,
    height: 169,
    rx: 5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1362 45.7279C27.9079 45.7279 29.3441 44.2917 29.3441 42.5201C29.3441 40.7484 27.9079 39.3123 26.1362 39.3123C24.3646 39.3123 22.9285 40.7484 22.9285 42.5201C22.9285 44.2917 24.3646 45.7279 26.1362 45.7279Z",
    fill: "#9E007E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7307 45.7279C39.5023 45.7279 40.9386 44.2917 40.9386 42.5201C40.9386 40.7484 39.5023 39.3123 37.7307 39.3123C35.9591 39.3123 34.5229 40.7484 34.5229 42.5201C34.5229 44.2917 35.9591 45.7279 37.7307 45.7279Z",
    fill: "#428DFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.333 45.7279C51.1046 45.7279 52.5409 44.2917 52.5409 42.5201C52.5409 40.7484 51.1046 39.3123 49.333 39.3123C47.5614 39.3123 46.1252 40.7484 46.1252 42.5201C46.1252 44.2917 47.5614 45.7279 49.333 45.7279Z",
    fill: "#23286B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.624 50.9419H16.5742V52.0903H218.624V50.9419Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.595 62.4719L65.4583 79.4639L86.8131 182.691L168.95 165.699L147.595 62.4719Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.844 145.052C109.519 147.601 97.4597 139.677 94.9099 127.351C92.36 115.026 100.285 102.967 112.61 100.417C124.936 97.8669 136.995 105.792 139.545 118.117C142.095 130.443 134.17 142.502 121.844 145.052Z",
    fill: "#9E007E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.323 115.959L105.099 111.74L132.116 129.508L129.338 133.73L102.323 115.959Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.984 107.833L128.205 110.604L110.459 137.635L106.234 134.861L123.984 107.833Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8297 77.9488L73.0856 79.1855L66.3689 80.575L87.464 182.546L168.393 165.804L147.298 63.8329L102.782 73.0422L102.526 71.8054L147.653 62.4699C147.986 62.401 148.314 62.5909 148.391 62.962L169.742 166.17C169.819 166.541 169.593 166.846 169.26 166.915L87.1095 183.909C86.7765 183.978 86.448 183.788 86.3712 183.417L65.0203 80.2092C64.9435 79.8382 65.1697 79.5335 65.5027 79.4646L72.8297 77.9488Z",
    fill: "#151515"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1484 191.494L17.1484 76.5552L16 76.5552L16 191.494L17.1484 191.494Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOrderRefundPopupNoTestsForRefund);
export default __webpack_public_path__ + "static/media/account--OrderRefundPopup__no-tests-for-refund.da9ec5dfbf487b0248ff076e1a2d59eb.svg";
export { ForwardRef as ReactComponent };